import { jsxs as d, jsx as l } from "react/jsx-runtime";
const n = (e) => /* @__PURE__ */ d("svg", { xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ l("path", { fillRule: "evenodd", d: "m15.707 14.293-1.414 1.414L10 11.414l-4.293 4.293-1.414-1.414L10 8.586l5.707 5.707Z", clipRule: "evenodd" }),
  /* @__PURE__ */ l("path", { fillRule: "evenodd", d: "m4.293 5.707 1.414-1.414L10 8.586l4.293-4.293 1.414 1.414L10 11.414 4.293 5.707Z", clipRule: "evenodd" })
] });
export {
  n as IconSmallClose
};
